import { render, staticRenderFns } from "./dog-sex-select.vue?vue&type=template&id=1cb35bc1&"
import script from "./dog-sex-select.vue?vue&type=script&lang=js&"
export * from "./dog-sex-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports